import { useEffect, useState } from 'react'
import './nameDialog.css'
import { FolderNode, getNodeById } from '../WooNotes/folders'
import { GUID } from '../Services/ServiceTypes'
import { WooNotesButton, WooNotesButtonSize, WooNotesButtonColor } from '../WooNotes/WooNotesButton'

type Props = {
  nodeId: GUID | undefined
  folderNodes: FolderNode[]
  onSave: (name: string) => void
  onCancel: () => void
}

export const RenameNodeDialog = ({ nodeId, folderNodes, onSave, onCancel }: Props) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (!nodeId) return

    const node = getNodeById(folderNodes, nodeId)
    if (!node) return
    setValue(node.name)
  }, [nodeId])

  useEffect(() => {
    if (!nodeId) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel()
      if (e.key === 'Enter' && value.trim()) onSave(value)
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [nodeId, value, onCancel, onSave, folderNodes])

  if (!nodeId) return null

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        <h3>Rename</h3>

        <input autoFocus value={value} onChange={e => setValue(e.target.value)} placeholder="Enter name" />

        <div className="actions">
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.White} onClick={() => onCancel()}>
            Cancel
          </WooNotesButton>
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.Blue} disabled={!value.trim()} onClick={() => onSave(value)}>
            Save
          </WooNotesButton>
        </div>
      </div>
    </div>
  )
}
